<div class="container">
  <app-general-header title="Resources" />
  <app-resources-subnav />
  <div class="card border-0 p-3">
    <div class="card-body">
      <app-my-resources-list></app-my-resources-list>
    </div>
  </div>
</div>
